import styled from 'styled-components'

import { BREAKPOINTS, COLOURS } from 'resources'

import RoundedButton from 'components/RoundedButton'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${COLOURS.neutralWhite};
  padding: 20px;
  max-width: 620px;
  margin: 0 auto;
`

export const Title = styled.div`
  font-family: 'Druk', sans-serif;
  color: ${COLOURS.neutralBlack};
  font-size: 36px;
  line-height: 1;
  text-align: center;
  margin-bottom: 20px;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 45px;
  }
`

export const Message = styled.p`
  margin: 10px 0 25px;
  font-size: 18px;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 20px;
  }
`

export const SupportLink = styled.a`
  color: ${COLOURS.primaryBlue};

  &:hover {
    text-decoration: none;
    opacity: 0.7;
  }
`

export const ConfirmButton = styled(RoundedButton)`
  margin-top: 30px;
  width: 100%;
`
